export enum CompanyVerificationStage {
  NOT_STARTED = 'NOT_STARTED',
  THIRD_PARTY_CHECKS_INITIATED = 'THIRD_PARTY_CHECKS_INITIATED',
  THIRD_PARTY_CHECKS_COMPLETED_VERIFIED = 'THIRD_PARTY_CHECKS_COMPLETED_VERIFIED',
  THIRD_PARTY_CHECKS_COMPLETED_REJECTED = 'THIRD_PARTY_CHECKS_COMPLETED_REJECTED',
  COMPLETED_VERIFIED = 'COMPLETED_VERIFIED',
  COMPLETED_REJECTED = 'COMPLETED_REJECTED',
}

export interface Company {
  id: number;
  name: string;
  registrationCountry: string;
  registrationId: string;
  contactEmail: string;
  verificationStage: CompanyVerificationStage;
  detailsLocked: boolean;
  address?: string;
  city?: string;
  phoneNumber?: string;
  operatingCountry?: string;
  phoneCountryCode?: string;
  website?: string;
  zipCode?: string;
}
